import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Job = {
  id: string;
  name: string;
  progress: number;
  status: 'processing' | 'completed' | 'pending' | 'errored';
};

export interface JobsState {
  jobs: Job[];
}

const initialState: JobsState = {
  jobs: [],
};

export const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    setJobs: (state, action: PayloadAction<Job[]>) => {
      state.jobs = action.payload;
    },
  },
});

export const {
  setJobs,
} = jobsSlice.actions;

export default jobsSlice.reducer;
